import { Deferred } from '@trello/deferred';

import type { QuickLoadOperations } from '../operation-to-quickload-url.generated';

export const deferredQuickLoads: Record<
  QuickLoadOperations,
  Deferred<null> | null
> = {
  // eslint-disable-next-line @trello/no-module-logic
  CurrentBoardInfo: new Deferred(),
  // eslint-disable-next-line @trello/no-module-logic
  CurrentBoardListsCards: new Deferred(),
  MemberHeader: null,
  MemberBoardsHome: null,
  MemberBoards: null,
  // eslint-disable-next-line @trello/no-module-logic
  TrelloCurrentBoardInfo: new Deferred(),
  MemberQuickBoards: null,
  QuickBoardsSearch: null,
  PreloadCard: null,
  OrganizationBillingPage: null,
  // eslint-disable-next-line @trello/no-module-logic
  TrelloBoardMirrorCards: new Deferred(),
  WorkspaceBoardsPageMinimal: null,
  WorkspaceHomePageMinimal: null,
};
